module.exports = __webpack_public_path__ + "static/media/logo_lapatisserie.cf8e4e47.webp";